import { withStyles } from '@mui/styles';
import React, { useCallback, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import { InputAdornment } from '@mui/material';
import * as Validations from '../helper/Validations';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginRight: theme.spacing(1),
    width: 200,
  },
});

const SingleTextInput = React.memo(function SingleTextInput({
  classes,
  placeholder,
  type,
  isMoney,
  isPercentage,
  currencySymbol,
  validations = [],
  title,
  value,
  onChange,
  preventError,
  errorMessage,
  path,
  updateMoneyValidation,
}) {
  const onModify = useCallback(e => onChange(e.target.value), [onChange]);

  let hasError = false;
  let validationMessage = '';

  if (validations.length) {
    validations.forEach(method => {
      if (!Validations[method](value)) {
        hasError = true;
        // Get specific error message for money validation
        if (method === 'validateMoney') {
          validationMessage = Validations.getMoneyValidationMessage(value);
        }
      }
    });
  }

  // Trigger money validation when value changes
  useEffect(() => {
    if (path && updateMoneyValidation && validations.includes('validateMoney')) {
      const isValid = Validations.validateMoney(value);
      updateMoneyValidation(path, value, isValid);
    }
  }, [value, path, updateMoneyValidation, validations]);

  // Use custom error message if provided, otherwise use validation message
  const displayError = hasError && (errorMessage || validationMessage);

  return (
    <div className={classes.container}>
      <TextField
        placeholder={placeholder || title}
        className={classes.textField}
        onChange={onModify}
        value={value || ''}
        error={(validations && hasError) || preventError}
        helperText={displayError}
        type={type}
        InputProps={{
          startAdornment:
            (isMoney && <InputAdornment position="start">{currencySymbol}</InputAdornment>) ||
            (isPercentage && <InputAdornment position="start">%</InputAdornment>),
        }}
        variant="standard"
      />&nbsp;&nbsp;&nbsp;
    </div>
  );
});

export default withStyles(styles)(SingleTextInput);
